export const nameCleaner = (name: string): string => {
  let cleanName = name;
  if (typeof name === "string" && name.includes("@")) {
    cleanName = name.substring(name.indexOf("@"), 0);
  }
  return cleanName;
};
